import React, { useContext } from 'react'
import { replaceYear } from '../../utils'
import { Script } from 'gatsby'
import replaceText from '../../utils/replaceText'

const FaqSchema = ({ faqs,tokens }) => {
  if (!faqs.length) return null
  return (
    <Script
      defer
      type="application/ld+json"
      // eslint-disable-next-line
      dangerouslySetInnerHTML={{
        __html: `
          ${JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((item) => ({
            '@type': 'Question',
            name: replaceText(tokens, item.question),
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answerNode?.childMarkdownRemark?.html,
            },
          })),
        })}
        `,
      }}
    />
  )
}

export default FaqSchema
